class BrixRichText {
  static init(...parameters) {
    return new BrixRichText(...parameters);
  }

  constructor(block) {
    if (block) {
      this.block = block;
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-rich-text', BrixRichText.init);
}
